const DATA_TYPE = {
    STRING: 'String',
    NUMBER: 'Number',
    PERSONAL_NAME: 'PN',
}

const VR_DATA_TYPES = {
    'AE': DATA_TYPE.STRING,
    'AS': DATA_TYPE.STRING,
    'AT': DATA_TYPE.STRING,
    'CS': DATA_TYPE.STRING,
    'DA': DATA_TYPE.STRING,
    'DS': DATA_TYPE.NUMBER,
    'DT': DATA_TYPE.STRING,
    'FL': DATA_TYPE.NUMBER,
    'FD': DATA_TYPE.NUMBER,
    'IS': DATA_TYPE.NUMBER,
    'LO': DATA_TYPE.STRING,
    'LT': DATA_TYPE.STRING,
    'PN': DATA_TYPE.PERSONAL_NAME,
    'SH': DATA_TYPE.STRING,
    'SL': DATA_TYPE.NUMBER,
    'SS': DATA_TYPE.NUMBER,
    'ST': DATA_TYPE.STRING,
    'TM': DATA_TYPE.STRING,
    'UI': DATA_TYPE.STRING,
    'UL': DATA_TYPE.NUMBER,
    'US': DATA_TYPE.NUMBER,
    'UT': DATA_TYPE.STRING,
}


export const getDicomJsonObjectValue = (dicomJsonObject) => {

    const valueRepresentation = dicomJsonObject.vr;
    const dataType = VR_DATA_TYPES[valueRepresentation];

    switch (dataType) {
        case DATA_TYPE.STRING:
            return getStringValue(dicomJsonObject);
        case DATA_TYPE.NUMBER:
            return getNumberValue(dicomJsonObject);
        case DATA_TYPE.PERSONAL_NAME:
            return getPersonNameValue(dicomJsonObject);
        default:
            return null;
    }
}

export const getStringValue = (dicomJsonObject) => { 
    if (dicomJsonObject && dicomJsonObject.Value && dicomJsonObject.Value.length) {
        return dicomJsonObject.Value.join('\\');
    }
    return null;
}

export const getNumberValue = (dicomJsonObject) => {
    if (dicomJsonObject && dicomJsonObject.Value && dicomJsonObject.Value.length) {
        return dicomJsonObject.Value[0];
    }
    return null;
}

export const getPersonNameValue = (dicomJsonObject) => {
    if (dicomJsonObject && dicomJsonObject.Value && dicomJsonObject.Value.length) {
        return (dicomJsonObject.Value[0].Alphabetic) || dicomJsonObject.Value[0];
    }
    return null;
}
